export default __webpack_public_path__ + "static/lutein-restartirat-zrenieto-tablet-7db61e6826e216aedf0fdb969ddc4fe5.jpg";